import React from 'react'
import '../styles/ErrorPage.css'
export default function ErrorPage() {
    return (
        <div className="ErrorContainer">
            <p style={{fontFamily:'Poppins-Regular',fontSize:18 }}>An error occured while loading the page, please try again later</p>
        </div>
    )
}